export const GET_LIST = '/machinery/get_list';
export const SHOW_DATA = '/machinery/show_data';
export const CREATE_DATA = '/machinery/create_data';
export const UPDATE_DATA = '/machinery/update_data';
export const REMOVE_DATA = '/machinery/remove_data';


export const FORM_DATA = {
  depreciation_rate: '',
  from: '',
  to: '',
};